import { useNavigate, useLocation } from "react-router-dom";

function Link(props) {
    const {icon, name, href, extraStyling, disabled, parent} = props;

    const navigate = useNavigate();
    const location = useLocation();

    const handleClick = () => {
        navigate(href);
    }

    return (
        <div
            {...(disabled ? "" : {onClick: handleClick})}
            className={
                (disabled ? "opacity:50 cursor-default text-slate-400 "
                    : "cursor-pointer hover:text-primary-600 ") +
                extraStyling +
                " py-5 pl-6 flex items-center font-medium " +
                "transition duration-400 transition-all " +
                (location.pathname === href ?
                    parent ?
                        "text-primary-600 lg:bg-gradient-to-r lg:from-primary-50 lg:to lg:bg-white"
                        :
                        "text-primary-600 lg:bg-gradient-to-l lg:from-primary-50 lg:to lg:bg-white"
                    : "text-indigo-900")
            }
        >
            {icon}
            {name}
        </div>
    );
}

export default Link;